"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _Table = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const Z_INDEX_STICKY = 100;
const BORDER = '1px solid rgba(224,224,224,1)';
const StickyContainer = (0, _styles.styled)('div')({
  position: 'sticky',
  top: '0px',
  zIndex: Z_INDEX_STICKY,
  backgroundColor: '#FFF',
  borderTop: BORDER
});
const HeaderCell = (0, _styles.styled)(_TableCell.default, {
  shouldForwardProp: prop => prop !== '$pad'
})(_ref => {
  let {
    theme,
    $pad
  } = _ref;
  return _objectSpread({
    position: 'sticky',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    zIndex: Z_INDEX_STICKY,
    backgroundColor: theme.palette.table.header.primary.main,
    color: theme.palette.table.header.primary.contrastText,
    borderColor: theme.palette.table.header.primary.main,
    borderBottom: BORDER
  }, !!$pad && {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  });
});
const BodyRow = (0, _styles.styled)(_TableRow.default, {
  shouldForwardProp: prop => prop !== '$striped' && prop !== '$isEven'
})(_ref2 => {
  let {
    theme,
    $striped,
    $isEven
  } = _ref2;
  return _objectSpread({
    borderBottom: BORDER,
    padding: 0
  }, !!$striped && !!$isEven && {
    background: theme.palette.table.body.secondary.main
  });
});
const ColumnCell = (0, _styles.styled)(_TableCell.default, {
  shouldForwardProp: prop => prop !== '$isActions' && prop !== '$pad'
})(_ref3 => {
  let {
    theme,
    $isActions,
    $pad
  } = _ref3;
  return _objectSpread(_objectSpread({
    flexDirection: 'column',
    justifyContent: 'center'
  }, !!$isActions && {
    textAlign: 'center'
  }), !!$pad && {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  });
});
const ActionsCellContainer = (0, _styles.styled)('div')(_ref4 => {
  let {
    theme
  } = _ref4;
  return {
    justifyContent: 'space-between',
    display: 'flex',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  };
});
const HeaderAction = (0, _styles.styled)('div', {
  shouldForwardProp: prop => prop !== '$row'
})(_ref5 => {
  let {
    $row
  } = _ref5;
  return _objectSpread({
    width: '100%',
    display: 'inline-block',
    textAlign: 'center',
    verticalAlign: 'middle'
  }, !!$row && {
    height: '100%'
  });
});
const COLUMN_DATAKEY_ACTIONS = 'actions';
class BlankComponent extends _react.default.Component {
  componentDidMount() {
    if (typeof this.props.didMount === 'function') {
      this.props.didMount();
    }
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
}

/**
 * ウィンドウスクローラーテーブル部品
 * @prop {array} columns - カラム情報
 * @prop {string} columns.dataKey - データキー(rowDataの属性名と一致させる)<br/>
 *  'actions'を指定した列はボタン表示列として幅が固定化される
 * @prop {node} columns.label - ヘッダに表示するラベル
 * @prop {number} columns.width - 列幅の割合（描画時のwidthはウィンドウサイズに応じて自動計算される）
 * @prop {object} [column.cellStyle] - セルのスタイル
 * @prop {array|object} rowData - 一覧に表示するデータ(objectで渡す場合rowGetter必須)
 * @prop {func} createRow - データからデータキーを属性名とするコンポーネントオブジェクトを作成する<br/>
 *  シグネチャ:(rowData[index]:object): object{[データキー]:コンポーネント,...}
 * @prop {bool} [putTypography] - カラム描画時にTypographyコンポーネントを追加する時に指定する
 * @prop {bool} [columnPadding] - カラムの左右にpadding spaceを付ける時に指定する
 * @prop {bool} [striped] - 一覧表示を偶数行と奇数行で色分けするときに指定する
 * @prop {node} [stickyContents] - 一覧ヘッダー上部に固定表示するコンテンツがあれば指定する
 * @prop {number} [headerHeight] - ヘッダの高さ（デフォルト：40）
 * @prop {number} [customActionWidth] -一覧内に表示するボタン領域の横幅
 * @prop {func} [getRowData] - 一覧に表示するデータの配列を取得する<br/>
 *  シグネチャ:(rowData:object|array): array
 * @prop {bool} [reload] -検索ボタン押下以外で一覧の内容を変更する場合true
 */
class ScrollerTable extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "blankComponentDidMount", () => {
      this.setState({
        rowDataChanging: false
      });
    });
    _defineProperty(this, "_headerLabelRenderer", (column, direction) => {
      const {
        putTypography,
        actionWidth,
        headerHeight,
        tableWidth,
        columnPadding
      } = this.props;
      const colWidth = this._getColumnWidth(column.dataKey, tableWidth, column.width);
      return /*#__PURE__*/_react.default.createElement(HeaderCell, {
        key: ['TableColumn', column.dataKey, 'header'].join('_'),
        $pad: columnPadding,
        style: {
          top: headerHeight,
          width: colWidth
        }
      }, column.dataKey === COLUMN_DATAKEY_ACTIONS && Array.isArray(column.label) ? column.label.map((item, index) => /*#__PURE__*/_react.default.createElement(_Typography.default, {
        component: "div",
        key: 'actionsHeader_' + index,
        color: "inherit",
        variant: "body2",
        style: {
          width: actionWidth
        }
      }, /*#__PURE__*/_react.default.createElement(HeaderAction, {
        $row: direction === 'row'
      }, item))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, putTypography ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
        component: "div",
        color: "inherit",
        variant: "body2"
      }, column.label) : /*#__PURE__*/_react.default.createElement("div", {
        style: _objectSpread({}, column.cellStyle)
      }, column.label)));
    });
    _defineProperty(this, "_columnCellRenderer", (rowData, rowIndex) => {
      const {
        createRow,
        putTypography,
        columns,
        columnPadding
      } = this.props;
      return columns.map((_ref6, index) => {
        let {
          dataKey
        } = _ref6;
        const row = createRow(rowData, rowIndex)[dataKey];
        return /*#__PURE__*/_react.default.createElement(ColumnCell, {
          key: ['TableColumn', dataKey, index].join('_'),
          $isActions: dataKey === COLUMN_DATAKEY_ACTIONS,
          $pad: columnPadding
        }, dataKey === COLUMN_DATAKEY_ACTIONS ? this._actionsColumnRenderer(row) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, putTypography ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
          component: "div",
          variant: "body2"
        }, row) : /*#__PURE__*/_react.default.createElement("div", {
          style: _objectSpread({}, columns[index].cellStyle)
        }, " ", row)));
      });
    });
    _defineProperty(this, "_actionsColumnRenderer", items => {
      var _columns$find;
      const {
        columns
      } = this.props;
      const direction = (_columns$find = columns.find(e => {
        return e.dataKey === COLUMN_DATAKEY_ACTIONS;
      })) === null || _columns$find === void 0 ? void 0 : _columns$find.direction;
      return /*#__PURE__*/_react.default.createElement(ActionsCellContainer, {
        style: {
          flexDirection: direction === 'row' ? 'row' : direction
        }
      }, Array.isArray(items) && items.map((item, index) => /*#__PURE__*/_react.default.createElement("div", {
        key: 'actionsItem_' + index
      }, item)));
    });
    _defineProperty(this, "_getColumnWidth", (dataKey, rowWidth, colWidth) => {
      const {
        columns,
        columnPadding,
        actionWidth
      } = this.props;
      let actionsColumnCount = 0;
      let colWidthTotal = 0;
      columns.forEach(item => {
        if (item.dataKey === COLUMN_DATAKEY_ACTIONS) {
          actionsColumnCount = item.direction === 'row' ? Array.isArray(item.label) ? item.label.length : 1 : 1;
        } else {
          if (typeof item.width === 'number') {
            colWidthTotal += item.width;
          }
        }
      });
      const actionsWidth = actionsColumnCount ? actionsColumnCount * actionWidth + (columnPadding ? 8 * 2 : 0) : 0;
      if (dataKey === COLUMN_DATAKEY_ACTIONS) {
        return actionsWidth;
      }
      if (!colWidthTotal || colWidthTotal <= 0) {
        return rowWidth - actionsWidth;
      }
      const cw = typeof colWidth === 'number' ? colWidth : 0;
      return (rowWidth - actionsWidth) * (cw / colWidthTotal);
    });
    this.state = {
      rowDataChanging: false,
      procRowData: typeof props.getRowData === 'function' ? props.getRowData(props.rowData) : undefined
    };
    this.stickyRef = /*#__PURE__*/_react.default.createRef();
  }
  componentDidMount() {}
  componentDidUpdate(prevProps) {
    if (!this.props.reload && !prevProps.reload && _lodash.default.differenceWith(prevProps.rowData, this.props.rowData).length) {
      this.setState({
        rowDataChanging: true,
        procRowData: typeof this.props.getRowData === 'function' ? this.props.getRowData(this.props.rowData) : undefined
      });
    } else if (prevProps.getRowData !== this.props.getRowData) {
      this.setState({
        procRowData: this.props.getRowData(this.props.rowData)
      });
    }
  }
  componentWillUnmount() {}
  render() {
    const {
      stickyContents,
      columns,
      headerHeight,
      striped,
      lastRowClassName
    } = this.props;
    const procRowData = this.state.procRowData ? this.state.procRowData : this.props.rowData;
    if (this.state.rowDataChanging) {
      return /*#__PURE__*/_react.default.createElement(BlankComponent, {
        didMount: this.blankComponentDidMount
      });
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, typeof stickyContents !== 'undefined' && /*#__PURE__*/_react.default.createElement(StickyContainer, {
      style: {
        height: headerHeight
      }
    }, stickyContents), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Table.default, null, /*#__PURE__*/_react.default.createElement(_TableHead.default, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, {
      key: ['TableHeadRow', 'header'].join('_')
    }, columns.map((column, index) => {
      return this._headerLabelRenderer(column, columns[index].direction);
    }))), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, procRowData.map((rowData, index) => {
      return /*#__PURE__*/_react.default.createElement(BodyRow, {
        key: ['TableBodyRow', index].join('_'),
        $striped: striped,
        $isEven: striped && index % 2 !== 0,
        className: lastRowClassName && index === procRowData.length - 1 ? lastRowClassName : undefined
      }, this._columnCellRenderer(rowData, index));
    })))));
  }
}
ScrollerTable.defaultProps = {
  headerHeight: 40,
  actionWidth: 64
};
ScrollerTable.propTypes = {
  rowData: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object]).isRequired,
  createRow: _propTypes.default.func.isRequired,
  putTypography: _propTypes.default.bool,
  columnPadding: _propTypes.default.bool,
  striped: _propTypes.default.bool,
  stickyContents: _propTypes.default.node,
  headerHeight: _propTypes.default.number,
  actionWidth: _propTypes.default.number,
  getRowData: _propTypes.default.func,
  reload: _propTypes.default.bool
};
var _default = exports.default = ScrollerTable;